import { render, staticRenderFns } from "./radioBox.vue?vue&type=template&id=24fb862b&scoped=true&"
import script from "./radioBox.vue?vue&type=script&lang=js&"
export * from "./radioBox.vue?vue&type=script&lang=js&"
import style0 from "./radioBox.vue?vue&type=style&index=0&id=24fb862b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb862b",
  null
  
)

export default component.exports